const { h, render, Component } = require('preact');
const Web2018Helper = require('../../../helper');
import { route } from 'preact-router';

function handleSigin(selectedInbentaResult) {
    selectedInbentaResult = _.omit(selectedInbentaResult, 'answer', 'bloodhoundTracking');
    const configFromDom = Groupon.Utils.getConfigFromDom();
    let queryString = Web2018Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult, { encode: false })
    let referenceUrl = `${configFromDom.SUPPORTBASEURL}?${queryString}`
    window.location.href = `/login?return_to=${encodeURIComponent(referenceUrl)}`
}

function handleGuestHelp(article, cb) {
    cb(article);
    route(getGuestCheckoutURL());
}

function getGuestCheckoutURL() {
    const configFromDom = Groupon.Utils.getConfigFromDom();
    if (configFromDom && configFromDom.SUPPORTBASEURL)
        return `${configFromDom.SUPPORTBASEURL}/web/guest`
}

function bhwAttr(article) {
    return `${article.contentId}_category_${article.dropdownCategory}_subcategory_${article.dropdownSubcategory}`
}

function GuestHelp(props) {
    const article = props.article || {};
    return (
        <div class="guest-help-options">
            <p>
                {I18n.translate("js.modules.web_2018.guest_help_need_to_contact")}
            </p>
            <div class="guest-help-options-row">
                <div class="guest-help-options-column">
                    <button onclick={() => handleSigin(article)} class="btn sign_in_sign_up_button" data-bhw={`web2018_${bhwAttr(article)}_guest_checkout_help_sigin_signup`}>
                        {I18n.translate("js.modules.web_2018.sign_in_sign_up")}
                    </button>
                </div>
                <div class="guest-help-options-column">
                    <button onClick={() => handleGuestHelp(article, props.onClickHelp)}
                        class="btn btn-invert guest_checkout_button"
                        data-bhw={`web2018_${bhwAttr(article)}_guest_checkout_help`}>
                        {I18n.translate("js.modules.web_2018.guest_checkout")}
                    </button>
                </div>
            </div>
        </div>
    );
}

module.exports = GuestHelp;